import { Injectable, PLATFORM_ID, Inject } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import { StorageService } from '../service/storage.service';
import { GuestTokenService } from '../service/guest-token.service';
import { AuthService } from '../service/auth.service';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { AdminDataService } from '../service/admin-data.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router, 
    private storage: StorageService,
    private guestTokenService: GuestTokenService,
    private authService: AuthService,
    private adminDataService: AdminDataService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  canActivate(): boolean | Observable<boolean> {
    if (!isPlatformBrowser(this.platformId)) {
      return false; // Or true depending on SSR requirements
    }

    const token = this.guestTokenService.authToken;
    // console.log('[AuthGuard] App startup - Is authToken present in localStorage?', !!token);

    if (!token) {
      // console.log('[AuthGuard] No token found, redirecting to signin');
      this.router.navigate(['/signin']);
      return false;
    }

    const isExpired = this.guestTokenService.isAuthTokenExpired();
    // console.log('[AuthGuard] App startup - Is authToken expired?', isExpired);

    if (isExpired) {
      // console.log('[AuthGuard] Token is expired, attempting refresh before redirecting to login...');
      return this.authService.refreshToken().pipe(
        map((res: any) => {
          if (res && res.access_token) {
            // console.log('[AuthGuard] Refresh successful, proceeding to route');
            this.guestTokenService.setAuthToken(res.access_token);
            this.checkAndPreloadAdminData();
            return true;
          }
          // console.log('[AuthGuard] Refresh did not return access_token, redirecting to signin');
          this.router.navigate(['/signin']);
          return false;
        }),
        catchError((err) => {
          console.error('[AuthGuard] Refresh failed during guard check:', err);
          this.router.navigate(['/signin']);
          return of(false);
        })
      );
    }

    this.checkAndPreloadAdminData();
    return true;
  }

  private checkAndPreloadAdminData(): void {
    if (this.adminDataService.isAdmin()) {
      this.adminDataService.loadAdminAdditionalData().subscribe();
    }
  }
}

